/**
 * @desc Export table layout configuration.
 * @example
 * import { layoutConfig } from 'config/table-configs/claim-detail';
 */
export const layoutConfig = {
    dimensions: {
        maxHeight: 260,
        padding: 0,
    },
    columnWidth: {
        claimNumber: 115,
        filingDate: 80,
        drugName: 150,
        rxNumber: 60,
        pharmacy: 150,
        status: 80,
        memberCost: 90,
        planPaidAmount: 100,
        
        // special columns
        _selectionActions: 16, // checkbox selection
        _groupActions: 70, // group actions column
    },
    filterFlyoutWidths: {
        claimNumber: 200,
        rxNumber: 180,
        status: 300,
    },
    valueColors: {},
    actionIcons: {
        toDos: 'checkedContent',
    },
};
